module.exports = __webpack_public_path__ + "03_glasses_red.01500138.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/boy/layer4/03_glasses_red.png
// module id = 9HUe
// module chunks = 0